import { render, staticRenderFns } from "./AutoRefreshCountdownLabel.vue?vue&type=template&id=6990d0d5&"
import script from "./AutoRefreshCountdownLabel.vue?vue&type=script&lang=js&"
export * from "./AutoRefreshCountdownLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports